import React, { Fragment, Component } from 'react';
import { CustomInput, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import { Card } from 'reactstrap';
import { remove, find } from 'lodash';
import Spinner from '~/components/spinner/spinner';
import TankTypeText from '~/components/tankTypeText/tankTypeText';
import TankStatusText from '~/components/tankStatusText/tankStatusText';
import TankStatusIcon from '~/components/tankStatusIcon/tankStatusIcon';
import FilterInput from '~/components/filterInput/filterInput';
import TankListActions from '~/containers/tankListActions/tankListActions';
import URLParamBanner from '~/components/urlParamBanner/urlParamBanner';
import ErrorBoundaryContent from '~/components/errorBoundary/content';
import styles from './styles.css';

export const getTanksQuery = gql`
  query tanks($breweryId: Int!) {
    tanks(breweryId: $breweryId) {
      id
      name
      type
      volume
      status
    }
  }
`;

export class TanksList extends Component {
  state = {
    selectedTanks: [],
    filteredTanks: [],
    filterText: ''
  };

  onHeaderCheck = (event, tanks) => {
    event.preventDefault();

    const { selectedTanks, filteredTanks } = this.state;
    if (selectedTanks.length) {
      return this.setState({
        selectedTanks: []
      });
    }

    if (filteredTanks.length) {
      return this.setState({
        selectedTanks: filteredTanks
      });
    }

    return this.setState({
      selectedTanks: tanks
    });
  };

  onTankCheck = (event, tank) => {
    event.stopPropagation();

    const { selectedTanks } = this.state;
    if (!!find(selectedTanks, t => t.id === tank.id)) {
      remove(selectedTanks, t => t.id === tank.id);
    } else {
      selectedTanks.push(tank);
    }

    this.setState({
      selectedTanks: [].concat(selectedTanks)
    });
  };

  onFilterChange = (event, tanks) => {
    const { value } = event.target;
    if (!value.length) {
      return this.setState({
        filteredTanks: [],
        filterText: ''
      });
    }
    const filterValue = value.toLowerCase();

    const filteredTanks = tanks.filter(tank => {
      return (
        tank.type
          .replace('_', ' ')
          .toLowerCase()
          .indexOf(filterValue) !== -1 ||
        tank.volume.toString().indexOf(filterValue) !== -1 ||
        tank.name.toLowerCase().indexOf(filterValue) !== -1 ||
        tank.status
          .replace('_', ' ')
          .toLowerCase()
          .indexOf(filterValue) !== -1
      );
    });

    return this.setState({
      filterText: value,
      filteredTanks,
      selectedTanks: []
    });
  };

  deselectTanks = () => {
    this.setState({
      selectedTanks: []
    });
  };

  renderHeaderCheckbox = tanks => {
    const { selectedTanks, filteredTanks } = this.state;
    let checked = false;
    if (filteredTanks.length) {
      checked = filteredTanks.length === selectedTanks.length;
    } else {
      checked = tanks.length === selectedTanks.length;
    }
    return (
      <Label for="headerCheck" onClick={e => this.onHeaderCheck(e, tanks)}>
        <CustomInput
          readOnly
          id="headerCheck"
          checked={checked}
          type="checkbox"
          className={`${styles.headerCheckbox} center`}
        />
      </Label>
    );
  };

  render() {
    const { brewery, history } = this.props;

    return (
      <Query query={getTanksQuery} variables={{ breweryId: brewery.id }} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <ErrorBoundaryContent error={error} />;
          }

          const { filterText, filteredTanks, selectedTanks } = this.state;
          const tanks = filterText.length ? filteredTanks : data.tanks;
          return (
            <Fragment>
              <URLParamBanner name="tank" />
              <Card className="content">
                <div className="flex pa3 w-100">
                  <FilterInput onChange={e => this.onFilterChange(e, data.tanks)} className="flex-grow-1" />
                  <TankListActions selectedTanks={selectedTanks} refreshList={this.deselectTanks} />
                </div>
                <div>
                  <header className="flex ttu table-header pv2">
                    <div className="w-5 tc">{this.renderHeaderCheckbox(data.tanks)}</div>
                    <div className="w-20">Name</div>
                    <div className="w-50">Status</div>
                    <div className="w-10">Type</div>
                    <div className="w-15">Volume</div>
                  </header>
                  <div>
                    {tanks.map(tank => (
                      <div
                        className="flex pointer pv3 bt-divider row-hover items-center"
                        key={tank.id}
                        onClick={() => {
                          history.push(`/tanks/${tank.id}`);
                        }}
                      >
                        <div className="w-5 pl2 pr2 tc" onClick={e => this.onTankCheck(e, tank)}>
                          <Label>
                            <CustomInput
                              readOnly
                              type="checkbox"
                              checked={!!find(selectedTanks, t => t.id === tank.id)}
                              className={`${styles.checkbox} center`}
                            />
                          </Label>
                        </div>

                        <div className="w-20 pr2">
                          <strong>{tank.name}</strong>
                        </div>
                        <div className="w-50 pr2 flex items-center">
                          <TankStatusIcon className="mr2" status={tank.status} />
                          <TankStatusText capitalise status={tank.status} />
                        </div>
                        <div className="w-10 pr2">
                          <TankTypeText capitalise type={tank.type} />
                        </div>
                        <div className="w-15">{tank.volume}L</div>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            </Fragment>
          );
        }}
      </Query>
    );
  }
}

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(withRouter(TanksList));



// WEBPACK FOOTER //
// ./src/containers/tanksList/tanksList.jsx